import { useSyncExternalStore } from 'react';
import { Icon } from './ui';
import { tr } from '../lib/i18n';
import { currentMode, subscribeMode, toggleMode, type ColorMode } from '../lib/mode';

const FIRST_PAINT: ColorMode = 'light';

/**
 * Alternador claro/escuro do cabeçalho. Discreto de propósito: ícone pequeno,
 * sem texto, e a escolha fica guardada no navegador do visitante.
 */
export function ThemeToggle({ tone = 'light', className = '' }: { tone?: 'light' | 'dark'; className?: string }): JSX.Element {
  const mode = useSyncExternalStore(subscribeMode, currentMode, () => FIRST_PAINT);
  const dark = mode === 'dark';
  const label = dark ? tr('Usar tema claro') : tr('Usar tema escuro');
  const palette = tone === 'dark'
    ? 'text-chrome-ink hover:bg-white/10'
    : 'text-muted hover:bg-surface hover:text-graphite';

  return (
    <button
      type="button"
      onClick={() => toggleMode()}
      title={label}
      aria-label={label}
      aria-pressed={dark}
      className={`inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full transition-colors ${palette} ${className}`}
    >
      <Icon name={dark ? 'sun' : 'moon'} size={17} />
    </button>
  );
}
